module.exports = __webpack_public_path__ + "assets/images/recipe7.73f7b3d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/activity_page/recipes/recipe7.png
// module id = 1645
// module chunks = 3